import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _76b1f6de = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _5ddb0a4a = () => interopDefault(import('..\\pages\\have-a-card.vue' /* webpackChunkName: "pages_have-a-card" */))
const _3aef02f8 = () => interopDefault(import('..\\pages\\have-a-card\\index.vue' /* webpackChunkName: "pages_have-a-card_index" */))
const _c3a98864 = () => interopDefault(import('..\\pages\\have-a-card\\enrollment.vue' /* webpackChunkName: "pages_have-a-card_enrollment" */))
const _42fba3ae = () => interopDefault(import('..\\pages\\have-a-card\\success.vue' /* webpackChunkName: "pages_have-a-card_success" */))
const _435514dc = () => interopDefault(import('..\\pages\\rejection.vue' /* webpackChunkName: "pages_rejection" */))
const _3e1a0a0b = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages_unlock" */))
const _861621a2 = () => interopDefault(import('..\\pages\\upload-documents\\index.vue' /* webpackChunkName: "pages_upload-documents_index" */))
const _59ae6b1c = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _59923c1a = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _5959de16 = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _593daf14 = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _080f05b3 = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _0d00a06a = () => interopDefault(import('..\\pages\\insured\\eligibility.vue' /* webpackChunkName: "pages_insured_eligibility" */))
const _6fc0ac3a = () => interopDefault(import('..\\pages\\insured\\patient-auth.vue' /* webpackChunkName: "pages_insured_patient-auth" */))
const _23c776c1 = () => interopDefault(import('..\\pages\\insured\\patient-information.vue' /* webpackChunkName: "pages_insured_patient-information" */))
const _606f7c60 = () => interopDefault(import('..\\pages\\insured\\success.vue' /* webpackChunkName: "pages_insured_success" */))
const _64ee5a83 = () => interopDefault(import('..\\pages\\insured\\summary.vue' /* webpackChunkName: "pages_insured_summary" */))
const _3c223a3e = () => interopDefault(import('..\\pages\\need-a-card\\eligibility.vue' /* webpackChunkName: "pages_need-a-card_eligibility" */))
const _498352a4 = () => interopDefault(import('..\\pages\\need-a-card\\insurance.vue' /* webpackChunkName: "pages_need-a-card_insurance" */))
const _876235e6 = () => interopDefault(import('..\\pages\\need-a-card\\insurance-information.vue' /* webpackChunkName: "pages_need-a-card_insurance-information" */))
const _7c0a01e0 = () => interopDefault(import('..\\pages\\need-a-card\\prescriber-information.vue' /* webpackChunkName: "pages_need-a-card_prescriber-information" */))
const _422b012a = () => interopDefault(import('..\\pages\\need-a-card\\select-path.vue' /* webpackChunkName: "pages_need-a-card_select-path" */))
const _1850db52 = () => interopDefault(import('..\\pages\\need-a-card\\success.vue' /* webpackChunkName: "pages_need-a-card_success" */))
const _31d1ceaf = () => interopDefault(import('..\\pages\\patient\\patientSearch.vue' /* webpackChunkName: "pages_patient_patientSearch" */))
const _0dd5177a = () => interopDefault(import('..\\pages\\uninsured\\eligibility.vue' /* webpackChunkName: "pages_uninsured_eligibility" */))
const _64ce2611 = () => interopDefault(import('..\\pages\\uninsured\\offer-selection.vue' /* webpackChunkName: "pages_uninsured_offer-selection" */))
const _5ea5512a = () => interopDefault(import('..\\pages\\uninsured\\patient-auth.vue' /* webpackChunkName: "pages_uninsured_patient-auth" */))
const _5d493ccc = () => interopDefault(import('..\\pages\\uninsured\\patient-information.vue' /* webpackChunkName: "pages_uninsured_patient-information" */))
const _393224b9 = () => interopDefault(import('..\\pages\\uninsured\\success.vue' /* webpackChunkName: "pages_uninsured_success" */))
const _3db102dc = () => interopDefault(import('..\\pages\\uninsured\\summary.vue' /* webpackChunkName: "pages_uninsured_summary" */))
const _fe3e334a = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/error",
    component: _76b1f6de,
    name: "error"
  }, {
    path: "/have-a-card",
    component: _5ddb0a4a,
    children: [{
      path: "",
      component: _3aef02f8,
      name: "have-a-card"
    }, {
      path: "enrollment",
      component: _c3a98864,
      name: "have-a-card-enrollment"
    }, {
      path: "success",
      component: _42fba3ae,
      name: "have-a-card-success"
    }]
  }, {
    path: "/rejection",
    component: _435514dc,
    name: "rejection"
  }, {
    path: "/unlock",
    component: _3e1a0a0b,
    name: "unlock"
  }, {
    path: "/upload-documents",
    component: _861621a2,
    name: "upload-documents"
  }, {
    path: "/errors/400",
    component: _59ae6b1c,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _59923c1a,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _5959de16,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _593daf14,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _080f05b3,
    name: "errors-500"
  }, {
    path: "/insured/eligibility",
    component: _0d00a06a,
    name: "insured-eligibility"
  }, {
    path: "/insured/patient-auth",
    component: _6fc0ac3a,
    name: "insured-patient-auth"
  }, {
    path: "/insured/patient-information",
    component: _23c776c1,
    name: "insured-patient-information"
  }, {
    path: "/insured/success",
    component: _606f7c60,
    name: "insured-success"
  }, {
    path: "/insured/summary",
    component: _64ee5a83,
    name: "insured-summary"
  }, {
    path: "/need-a-card/eligibility",
    component: _3c223a3e,
    name: "need-a-card-eligibility"
  }, {
    path: "/need-a-card/insurance",
    component: _498352a4,
    name: "need-a-card-insurance"
  }, {
    path: "/need-a-card/insurance-information",
    component: _876235e6,
    name: "need-a-card-insurance-information"
  }, {
    path: "/need-a-card/prescriber-information",
    component: _7c0a01e0,
    name: "need-a-card-prescriber-information"
  }, {
    path: "/need-a-card/select-path",
    component: _422b012a,
    name: "need-a-card-select-path"
  }, {
    path: "/need-a-card/success",
    component: _1850db52,
    name: "need-a-card-success"
  }, {
    path: "/patient/patientSearch",
    component: _31d1ceaf,
    name: "patient-patientSearch"
  }, {
    path: "/uninsured/eligibility",
    component: _0dd5177a,
    name: "uninsured-eligibility"
  }, {
    path: "/uninsured/offer-selection",
    component: _64ce2611,
    name: "uninsured-offer-selection"
  }, {
    path: "/uninsured/patient-auth",
    component: _5ea5512a,
    name: "uninsured-patient-auth"
  }, {
    path: "/uninsured/patient-information",
    component: _5d493ccc,
    name: "uninsured-patient-information"
  }, {
    path: "/uninsured/success",
    component: _393224b9,
    name: "uninsured-success"
  }, {
    path: "/uninsured/summary",
    component: _3db102dc,
    name: "uninsured-summary"
  }, {
    path: "/",
    component: _fe3e334a,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
